import React, { useContext } from "react";
import { STYLE_DEFAULT_TAB_BED } from "App/constants";

import { TableCell, TableRow } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { headCells } from "./helpers";

import { TableWrapper } from "App/Component/ui";
import { FormContext } from "../../context/FormContext";
import { defaultDateDisplay, formatNumber, isNull } from "App/utils/helpers";

const useStyles = STYLE_DEFAULT_TAB_BED;

export default function TabPenyusutan() {
  const classes = useStyles();

  // const [rows] = useState();
  const { dataPenyusutan } = useContext(FormContext);


  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: dataPenyusutan,
    orderByDefault: "nama_barang",
    orderByRow: ["nama_barang"],
  });

  return (
    <div className={classes.root}>
      <TableWrapper
        title='Daftar Penyusutan'
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={dataPenyusutan}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        withPadding={true}
        >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {"-"}
                </TableCell>
                <TableCell align='left'>{row?.id}</TableCell>
                <TableCell align='left'>{row?.nama_barang}</TableCell>
                <TableCell align='left'>{row?.fixassets_id}</TableCell>
                <TableCell align='left'>{row?.idgl}</TableCell>
                <TableCell align='left'>{formatNumber(row?.jumlah)}</TableCell>
                <TableCell align='left'>{defaultDateDisplay(row?.tanggal)}</TableCell>
                <TableCell align='left'>{isNull(row?.remark) ? "-" : row?.remark}</TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row?.createdAt)}
                </TableCell>
                <TableCell align="left">
                  {row?.createdBy}
                </TableCell>
              </TableRow>
            );
          })}
      </TableWrapper>
    </div>
  );
}
